import React, { useRef, useEffect, useState } from 'react'
import {
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CFormTextarea,
  CCard,
  CCardBody,
  CButton,
  CModal,
  CModalHeader,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CBadge,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CFormSelect,
  CFormInput,
  CSpinner,
} from '@coreui/react'
import ImagingInformation from '../../services/general/ImagingAPI.api.js'
import HighlightedText from './../../components/shared/HighlightedText'
import CIcon from '@coreui/icons-react'
import { cilPencil, cilTrash } from '@coreui/icons'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Carder from '../../components/shared/Carder.jsx'
import PatientImagingsCRUD from '../../services/general/patientImagingData.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config.js'
import Graytextarea from '../../components/Graytextarea.jsx'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import moment from 'moment'
import { X } from 'lucide-react'
import Select from 'react-select'
import HighlightedTextImaging from './HighlghtedImaging.jsx'
import Highlighter from 'react-highlight-words'
import Editor, { Toolbar } from 'react-simple-wysiwyg'
import renderHighlightedText from './renderHighlightedText.jsx'

const PatientImaging = ({ patientID, loading, setLoading, imagingList, removeDiagnosisIdFromNote, saveTreatsShell, render, setRender, imagingTypeList, setImagingList, diagnosis, GetPatientImagings, updatePatientDiagnosis, noteStructureRef, showComment, setShowComment, addDiagnosisIdsToNote }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [date, setDate] = useState('')
  const [imagingType, setImagingType] = useState('')
  const [selectedImagingType, setSelectedImagingType] = useState(null)
  const [selectedImagingTypes, setSelectedImagingTypes] = useState([])
  const [impression, setImpression] = useState('')
  const [activeTab, setActiveTab] = useState('add')
  const [possibleDiagnosis, setPossibleDiagnosis] = useState([])
  const [diagnosisModalVisible, setDiagnosisModalVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const detectedKeywordsRef = useRef(new Set())
  const [editImagingId, setEditImagingId] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [comment, setComment] = useState(null)
  const [imagingNoteIdEdit, setImagingNoteIdEdit] = useState([])
  const [listImagings, setListImagings] = useState([])
  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')
   const [isSavingAll, setIsSavingAll] = useState(false)

  const [diagnosisActiveSelection, setDiagnosisActiveSelection] = useState(null)
  const [isAddingDiagnosis, setIsAddingDiagnosis] = useState(false)
  // { start, end, text, index } — index tracks WHICH item was selected in

  useEffect(() => {
    setDate(getFormattedDate())
  }, [patientID])

    const shouldCloseModalAfterSave = useRef(false)


  const getFormattedDate = (dateStr) => {
    const today = dateStr ? new Date(dateStr) : new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  const handleSaveImaging = async () => {
    filterDiagnosis()
  }

  const extractUniqueKeywords = (keywordsArray) => {
    // const allKeywords = keywordsArray?.flatMap((item) => item.keyword.split(',')).map((keyword) => keyword.trim())
    const allKeywords = Array.isArray(keywordsArray) ? keywordsArray.flatMap((item) => (typeof item?.keyword === 'string' ? item.keyword.split(',').map((k) => k.trim()) : [])) : []

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  const GetImagingsToQuick = async () => {
    try {
      let formattedData = await PatientImagingsCRUD('GET', patientID.toString())


      if (formattedData) {
        formattedData = JSON.parse(formattedData.d)
        formattedData = formattedData.Data.map((item) => {
          const parsedData = JSON.parse(item.data)
          const matchingType =
            parsedData &&
            imagingTypeList.find((type) => {
              return type?.Name.toString() === parsedData?.name?.toString()
            })
          return {
            ...item,
            data: {
              ...parsedData,
              keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords || []) : [],
            },
          }
        })

        console.log(imagingTypeList, "imagingTypeListimagingTypeList")

        return formattedData
      }
    } catch (error) {
      console.error('Error fetching patient imaging data', error)
    }
  }

  const saveImaging = async (date, selectedImagingType, impression, isEditing, editImagingId, selectedText = []) => {
    if (!date || !selectedImagingType || !impression) {
      // toast.error("Please fill the fields with information", toastConfig)
      return
    }
    setIsLoading(true)
    try {
      try {
        let diagnosisData = await GetDiagnosisData();
        let tempData = JSON.parse(diagnosisData.d)?.Data;

        const concatedAllImpression = impression;
        const sanitizedImpression = concatedAllImpression.replace(/[^a-zA-Z0-9\s]/g, '');

        const inputKeywords = sanitizedImpression
            .toLowerCase()
            .split(/\s+/)
            .filter((keyword) => keyword.trim() !== '');

        const matchedDiagnoses = tempData.filter((diag) => {
            const diagnosisKeywords = (diag?.Keywords || '').split(',').map((k) => k.trim().toLowerCase());
            let match = true;
            diagnosisKeywords.find((diagnosisKeyword) => {
                match = true;
                const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/);
                if (diagnosisKeywordParts.length > 1) {
                    let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0]);
                    if (foundIndex != -1) {
                        for (let i = 1; i <= diagnosisKeywordParts.length - 1; i++) {
                            if (inputKeywords.length < foundIndex + i) {
                                match = false;
                                break;
                            }
                            if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {
                                match = false;
                                break;
                            }
                        }
                    } else {
                        match = false;
                    }
                } else {
                    let foundKeyword = inputKeywords.includes(diagnosisKeyword);
                    if (!foundKeyword) {
                        match = false;
                    } else {
                        match = true;
                    }
                }
                if (match) return true;
            });
            return match;
        });

        let historyDiagnosis = {};
        matchedDiagnoses.forEach((diag) => {
            const diagName = diag.Name.trim();
            let existingData = noteStructureRef.current?.information?.[diagName] || [];
            if (!existingData.includes(`Imaging(${selectedImagingType.Name})`)) {
                historyDiagnosis[diagName] = [...existingData, `Imaging(${selectedImagingType.Name})`];
            }
        });

        if (Object.keys(historyDiagnosis).length > 0) {
            noteStructureRef.current = {
                ...noteStructureRef.current,
                information: {
                    ...noteStructureRef.current?.information,
                    ...historyDiagnosis,
                },
            };
        }
      } catch (err) {
          console.log('Error updating imaging information', err);
      }

      if (isEditing) {
        // const filteredKeywords = selectedImagingType.Keywords.map((item) => item.keyword)

        const filteredKeywords = Array.isArray(selectedImagingType.Keywords)
          ? selectedImagingType.Keywords.map((item) => item.keyword)
          : []
              .filter((item) => item !== '')
              .flatMap((item) => item.split(','))
              .map((keyword) => keyword.trim())

        const uniqueKeywords = Array.from(new Set(filteredKeywords))

        const newImagingWhichUpdated = {
          name: selectedImagingType.Name,
          imagingType,
          impression: impression,
          selectedText: selectedText,
          comment: comment,
          keywords: uniqueKeywords,
          priority: selectedImagingType.Priority,
        }

        await PatientImagingsCRUD('UPDATE', patientID.toString(), JSON.stringify(newImagingWhichUpdated), date?.toString(), editImagingId.toString())

        setDate(getFormattedDate())
        setImagingType('')
        setImpression('')
        setComment('')
        setSelectedImagingType(null)
        setEditImagingId(null)
        setModalVisible(false)
        setDiagnosisModalVisible(false)
        setRender((p) => !p)
      } else {
        // const filteredKeywords = selectedImagingType.Keywords.map((item) => item.keyword)

        const filteredKeywords = Array.isArray(selectedImagingType.Keywords)
          ? selectedImagingType.Keywords.map((item) => item.keyword)
          : []
              .filter((item) => item !== '')
              .flatMap((item) => item.split(','))
              .map((keyword) => keyword.trim())

        const uniqueKeywords = Array.from(new Set(filteredKeywords))

        const newImaging = {
          name: selectedImagingType.Name,
          imagingType,
          impression: impression,
          comment: comment,
          keywords: uniqueKeywords,
          selectedText: selectedText,
          priority: selectedImagingType.Priority,
        }

        await PatientImagingsCRUD('INSERT', patientID.toString(), JSON.stringify(newImaging), getFormattedDate(date).toString())
        const imagingListWithNew = await GetImagingsToQuick()

        if (imagingListWithNew.length > 0) {
          const lastImaging = imagingListWithNew[imagingListWithNew.length - 1]

          noteStructureRef.current = {
            ...noteStructureRef.current,
            metadata: {
              ...noteStructureRef.current.metadata,
              imagingIds: [...(noteStructureRef.current.metadata?.imagingIds || []), lastImaging?.id],
            },
          }

          setImagingNoteIdEdit((prev) => [...prev, lastImaging?.id])
          await saveTreatsShell(false)
          // toast.success('Successfully Save', toastConfig)
        }

        setDate(getFormattedDate())
        setImagingType('')
        setImpression('')
        setComment('')
        setSelectedImagingType(null)
        setModalVisible(false)
        setDiagnosisModalVisible(false)
        setListImagings([])
        setRender((p) => !p)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const imagingOptions = imagingTypeList.map((type) => ({
    value: type.ID,
    label: type.Name,
  }))

  const scrollToTopModal = () => {
    const modalElements = document.getElementsByClassName('imaging-tabs')
    if (modalElements.length > 0) {
      modalElements[0].scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }

  useEffect(() => {
    scrollToTopModal()
  }, [modalVisible])

  const handleDeleteImagingPatient = async (id) => {
    await PatientImagingsCRUD('DELETE', patientID.toString(), '', '', deleteVisibleId?.toString())
    await GetPatientImagings()
    setDeleteVisibleId(null)
    const filterListImaging = listImagings.filter((imaging, i) => imaging.editId !== deleteVisibleId)
    setListImagings(filterListImaging)
  }

  const handleSelectImaging = (e) => {
    const selectedType = imagingTypeList.find((i) => i.ID === parseInt(e.target.value))
    setImagingType(e.target.value || '')
    setSelectedImagingType(selectedType || null)
    setSelectedImagingTypes(selectedType ? [selectedType] : [])
  }

  const resetAddImagingForm = () => {
    setImpression('')
    setEditImagingId(null)
    setImagingType('')
    setDate(getFormattedDate())
    setSelectedImagingType(null)
    setSelectedImagingTypes([])
    setComment('')
    setEditIndexListId(null)
  }

  const filterDiagnosis = async () => {
    // if (!date || !selectedImagingType || !impression) {
    //     toast.error("Please fill the fields with information", toastConfig)
    //     return;
    // }

    if (listImagings.length == 0) {
      toast.error('Please add at least one impression', toastConfig)
      return
    }
    const concatedAllImpression = listImagings.map((item) => item.impression).join(' ')
    const sanitizedImpression = concatedAllImpression.replace(/[^a-zA-Z0-9\s]/g, '')

    // Split the sanitized impression into keywords
    const inputKeywords = sanitizedImpression
      .toLowerCase()
      .split(/\s+/)
      .filter((keyword) => keyword.trim() !== '')
    detectedKeywordsRef.current.clear() // Clear previous keywords

    let diagnosisData = await GetDiagnosisData()
    let tempData = JSON.parse(diagnosisData.d)?.Data

    const possibleDiagnosis = tempData.filter((diagnosis) => {
      const diagnosisKeywords = (diagnosis?.Keywords || '').split(',').map((keyword) => keyword.trim().toLowerCase())
      let match = true
      diagnosisKeywords.find((diagnosisKeyword) => {
        match = true

        const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/)
        if (diagnosisKeywordParts.length > 1) {
          let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0])

          if (foundIndex != -1) {
            for (let i = 1; i <= diagnosisKeywordParts.length - 1; i++) {
              if (inputKeywords.length < foundIndex + i) {
                match = false
                break
              }
              if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {
                match = false
                break
              }
            }
          } else {
            match = false
          }
        } else {
          let foundKeyword = inputKeywords.includes(diagnosisKeyword)
          if (!foundKeyword) {
            match = false
          } else {
            match = true
          }
        }
        if (match) {
          return true
        }
      })
      if (match) {
        diagnosisKeywords.forEach((keyword) => detectedKeywordsRef.current.add(keyword))
      }
      return match
    })
    let result = possibleDiagnosis.filter((item) => !diagnosis.includes(item.Name.trim()))
    setPossibleDiagnosis(result)
    if (result.length > 0) {
        setIsAddingDiagnosis(false) // ← add this
      setDiagnosisModalVisible(true)
    } else {
      setIsAddingDiagnosis(false)
      setDiagnosisModalVisible(true)
      return
      // we stop the directly adding cause of we also add highlighted text so opening the modal of detected diagnosis
      if (listImagings.length > 0) {
        for (const item of listImagings) {
          await saveImaging(item?.date, item?.selectedImagingType, item?.impression, item.type === 'existing', item?.editId, item?.selectedText)
        }

        toast.success('Successfully Save', toastConfig)
        await GetPatientImagings()
        setImpression('')
        setDate(getFormattedDate())
        setImagingType('')
        setComment('')
        setEditImagingId(null)
        setSelectedImagingType(null)
        setModalVisible(false)
        setDiagnosisModalVisible(false)
        setListImagings([])
        setRender((p) => !p)
      } else {
      }
    }
  }

  const handleDiagnosisSelection = (idx) => {
    const selection = window.getSelection()
    const text = selection?.toString().trim() || ''

    if (!text || !selection.rangeCount) {
      setDiagnosisActiveSelection(null)
      return
    }

    const range = selection.getRangeAt(0)
    const container = document.querySelector(`[data-impression="diagnosis-${idx}"]`)
    if (!container) {
      setDiagnosisActiveSelection(null)
      return
    }

    const start = getTextOffset(container, range.startContainer, range.startOffset)
    setDiagnosisActiveSelection({ start, end: start + text.length, text, index: idx })
  }

  const justGetDiagnosisOutofAllImpressions = async () => {
    if (listImagings.length == 0) {
      toast.error('Please add at least one impression', toastConfig)
      return
    }
    const concatedAllImpression = listImagings.map((item) => item.impression).join(' ')
    const sanitizedImpression = concatedAllImpression.replace(/[^a-zA-Z0-9\s]/g, '')

    // Split the sanitized impression into keywords
    const inputKeywords = sanitizedImpression
      .toLowerCase()
      .split(/\s+/)
      .filter((keyword) => keyword.trim() !== '')
    detectedKeywordsRef.current.clear() // Clear previous keywords

    let diagnosisData = await GetDiagnosisData()
    let tempData = JSON.parse(diagnosisData.d)?.Data

    const possibleDiagnosis = tempData.filter((diagnosis) => {
      const diagnosisKeywords = (diagnosis?.Keywords || '').split(',').map((keyword) => keyword.trim().toLowerCase())
      let match = true
      diagnosisKeywords.find((diagnosisKeyword) => {
        match = true

        const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/)
        if (diagnosisKeywordParts.length > 1) {
          let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0])

          if (foundIndex != -1) {
            for (let i = 1; i <= diagnosisKeywordParts.length - 1; i++) {
              if (inputKeywords.length < foundIndex + i) {
                match = false
                break
              }
              if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {
                match = false
                break
              }
            }
          } else {
            match = false
          }
        } else {
          let foundKeyword = inputKeywords.includes(diagnosisKeyword)
          if (!foundKeyword) {
            match = false
          } else {
            match = true
          }
        }
        if (match) {
          return true
        }
      })
      if (match) {
        diagnosisKeywords.forEach((keyword) => detectedKeywordsRef.current.add(keyword))
      }
      return match
    })
    let result = possibleDiagnosis.filter((item) => !diagnosis.includes(item.Name.trim()))
    setPossibleDiagnosis(result)
    if (result.length > 0) {
      setDiagnosisModalVisible(true)
    } else {
      toast.error('No Possible Diagnosis', toastConfig)
    }
  }

//   const getAvailableImagingOptions = () => {
//   const selectedImagingNames = listImagings.map(item => item.selectedImagingType?.Name).filter(Boolean);

//   console.log("imagingLists", listImagings)
  
//   return imagingTypeList.filter(type => !selectedImagingNames.includes(type.Name));
// }

const getAvailableImagingOptions = () => {
  return imagingTypeList
}

  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return ''
    const [year, month, day] = dateStr.split('-')
    return `${month}-${day}-${year}`
  }
  const handleRemoveDiagnosis = (indexToRemove) => {
    setPossibleDiagnosis((prevDiagnosis) => prevDiagnosis.filter((_, index) => index !== indexToRemove))
  }

  const addDiagnosis = async () => {
      setIsAddingDiagnosis(true)

      try {



       if (updateModalEditId) {
      let newDiagnosis = possibleDiagnosis.map((obj) => {
        return obj.Name.trim()
      })

      let historyDiagnosis = newDiagnosis.reduce((acc, item) => {
        let existingData = noteStructureRef.current?.information?.[item] || []

        if (!existingData.includes(`Imaging(${selectedImagingType?.Name})`)) {
          acc[item] = [...existingData, `Imaging(${selectedImagingType?.Name})`]
        } else {
          acc[item] = existingData
        }

        return acc
      }, {})

      noteStructureRef.current = {
        ...noteStructureRef.current,
        information: {
          ...noteStructureRef.current.information,
          ...historyDiagnosis,
        },
      }

      newDiagnosis = newDiagnosis.join(',')
      const diagnosisIds = possibleDiagnosis.map((item) => item.id)
      addDiagnosisIdsToNote(diagnosisIds)
      updatePatientDiagnosis(patientID, newDiagnosis)
      setModalVisible(false)

      // const filteredKeywords = selectedImagingType.Keywords.map((item) => item.keyword)

      const filteredKeywords = Array.isArray(selectedImagingType.Keywords)
        ? selectedImagingType.Keywords.map((item) => item.keyword)
        : []
            .filter((item) => item !== '')
            .flatMap((item) => item.split(','))
            .map((keyword) => keyword.trim())

      const uniqueKeywords = Array.from(new Set(filteredKeywords))

      const newImagingWhichUpdated = {
        name: selectedImagingType.Name,
        imagingType,
        impression: impression,
        comment: comment,
        // keywords: uniqueKeywords,
        priority: selectedImagingType.Priority,
        selectedText: highLightText,
      }

      await PatientImagingsCRUD('UPDATE', patientID.toString(), JSON.stringify(newImagingWhichUpdated), date?.toString(), updateModalEditId.toString())

      setDate(getFormattedDate())
      setImagingType('')
      setImpression('')
      setComment('')
      setSelectedImagingType(null)
      setEditImagingId(null)
      setModalVisible(false)
      setDiagnosisModalVisible(false)
      setListImagings([])
      setUpdateModaEditId(null)
      setRender((p) => !p)
      setPossibleDiagnosis([])
      setHighLightText([])
    } else {
      let newDiagnosis = possibleDiagnosis.map((obj) => {
        return obj.Name.trim()
      })

      let historyDiagnosis = newDiagnosis.reduce((acc, item) => {
        let existingData = noteStructureRef.current?.information?.[item] || []

        if (!existingData.includes(`Imaging(${listImagings[0]?.selectedImagingType?.Name})`)) {
          acc[item] = [...existingData, `Imaging(${listImagings[0]?.selectedImagingType?.Name})`]
        } else {
          acc[item] = existingData
        }

        return acc
      }, {})

      noteStructureRef.current = {
        ...noteStructureRef.current,
        information: {
          ...noteStructureRef.current.information,
          ...historyDiagnosis,
        },
      }

      newDiagnosis = newDiagnosis.join(',')
      const diagnosisIds = possibleDiagnosis.map((item) => item.id)
      addDiagnosisIdsToNote(diagnosisIds)
      updatePatientDiagnosis(patientID, newDiagnosis)
      setModalVisible(false)

      for (const item of listImagings) {
        await saveImaging(item?.date, item?.selectedImagingType, item?.impression, item.type === 'existing', item?.editId, item?.selectedText)
      }

      toast.success('Successfully Save', toastConfig)
      await GetPatientImagings()
      setImpression('')
      setDate(getFormattedDate())
      setImagingType('')
      setComment('')
      setEditImagingId(null)
      setSelectedImagingType(null)
      setModalVisible(false)
      setDiagnosisModalVisible(false)
      setListImagings([])
      setRender((p) => !p)
      setPossibleDiagnosis([])
       setHighLightText([])
    setIsSavingAll(false)  // ← Reset saving state
    setIsAddingDiagnosis(false)


    }



  } catch (error) {
    console.error('Error adding diagnosis:', error)
    toast.error('Failed to save. Please try again.', toastConfig)
    setIsAddingDiagnosis(false) // Re-enable only on error
        setIsSavingAll(false) 
  }



  
 
  }

  const [activeSelection, setActiveSelection] = useState(null)
  const [selectedIdx, setSelectedIdx] = useState(null)

  // this will handle edit with add modal like same
  const handleEditPatientImaging = (imaging) => {
    const findImagingMaster = imagingTypeList.find((i) => i.Name === imaging.data?.name)
    const editImaging = {
      editId: imaging?.id,
      date: imaging?.date,
      name: findImagingMaster?.Name,
      selectedImagingType: findImagingMaster,
      impression: imaging?.data?.impression,
      type: 'existing',
    }
    setListImagings((prevList) => [...prevList, editImaging])
    setActiveTab('add')
    setEditIndexListId(0)
    setImagingType(findImagingMaster?.ID)
    setImpression(imaging.data?.impression)
    setComment(imaging?.data?.comment)
    setEditImagingId(imaging.id)
    setSelectedImagingType(findImagingMaster)
    setSelectedImagingTypes(findImagingMaster ? [findImagingMaster] : [])
    setDate(imaging.date)
    setModalVisible(true)
  }

  const [updateModalEditId, setUpdateModaEditId] = useState(null)
  const [highLightText, setHighLightText] = useState([])

  const handleUpdatePatientImaging = (imaging) => {
    const findImagingMaster = imagingTypeList.find((i) => i.Name === imaging.data?.name)
    setImagingType(findImagingMaster?.ID)
    setImpression(imaging.data?.impression)
    setComment(imaging?.data?.comment)
    setUpdateModaEditId(imaging.id)
    setSelectedImagingType(findImagingMaster)
    setSelectedImagingTypes(findImagingMaster ? [findImagingMaster] : [])
    setDate(imaging.date)
    setHighLightText(imaging?.data?.selectedText)
  }

  const handleUpdateImaging = () => {}

  const handleAddImaging = () => {
      setIsSavingAll(false) // Reset loading state
  setIsLoading(false)
    setModalVisible(true)
    
  }

  useEffect(() => {
    const imagingIds = noteStructureRef.current?.metadata?.imagingIds || []
    setImagingNoteIdEdit(imagingIds)
  }, [])

  const [editIndexListId, setEditIndexListId] = useState(null)

  const handleEditListImaging = (index) => {
    setEditIndexListId(index)
    setActiveTab('add')
    const imaging = listImagings[index]
    const imagingFindValue = imagingTypeList.find((i) => i.Name === imaging?.selectedImagingType?.Name)
    setImagingType(imagingFindValue?.ID || '')
    setImpression(imaging?.impression)
    setComment(imaging?.data?.comment)
    setEditImagingId(imaging?.id)
    setSelectedImagingType(imagingFindValue)
    setSelectedImagingTypes(imagingFindValue ? [imagingFindValue] : [])
    setDate(imaging?.date)
  }

  const handleAddImagingtoList = async () => {
    if (editIndexListId || editIndexListId === 0) {
      const updatedListImagings = [...listImagings]
      updatedListImagings[editIndexListId].impression = impression
      updatedListImagings[editIndexListId].comment = comment
      updatedListImagings[editIndexListId].date = date
      updatedListImagings[editIndexListId].selectedImagingType = selectedImagingType
      updatedListImagings[editIndexListId].name = selectedImagingType?.Name || ''
      // const filteredKeywords = selectedImagingType.Keywords.map((item) => item.keyword)

      const filteredKeywords = Array.isArray(selectedImagingType.Keywords)
        ? selectedImagingType.Keywords.map((item) => item.keyword)
        : []
            .filter((item) => item !== '')
            .flatMap((item) => item.split(','))
            .map((keyword) => keyword.trim())
      updatedListImagings[editIndexListId].filteredKeywords = filteredKeywords
      setListImagings(updatedListImagings)
      resetAddImagingForm()
    } else {
      if (!date || selectedImagingTypes.length === 0 || !impression) {
        toast.error('Please fill the fields with information', toastConfig)
        return
      }
      const structures = selectedImagingTypes.map((type) => {
        const filteredKeywords = Array.isArray(type?.Keywords)
          ? type.Keywords.map((item) => item.keyword)
          : []
              .filter((item) => item !== '')
              .flatMap((item) => item.split(','))
              .map((keyword) => keyword.trim())

        return {
          date,
          selectedImagingType: type,
          filteredKeywords: filteredKeywords || [],
          name: type?.Name || '',
          impression,
          comment,
          type: 'new',
        }
      })

     setListImagings((prevList) => {
  const newList = [...prevList, ...structures]

  console.log('ADDING IMAGING:', structures)
  console.log('TOTAL LIST IMAGINGS:', newList.length)
  console.log('LIST IMAGINGS:', newList)

  return newList
})
      resetAddImagingForm()
      toast.success(`${structures.length} imaging item${structures.length > 1 ? 's' : ''} added to the list`, toastConfig)
    }
  }

  const continueWithoutSaving = async () => {
    setIsSavingAll(true)

    if (updateModalEditId) {
      // const filteredKeywords = selectedImagingType.Keywords.map((item) => item.keyword)

      const filteredKeywords = Array.isArray(selectedImagingType.Keywords)
        ? selectedImagingType.Keywords.map((item) => item.keyword)
        : []
            .filter((item) => item !== '')
            .flatMap((item) => item.split(','))
            .map((keyword) => keyword.trim())

      const uniqueKeywords = Array.from(new Set(filteredKeywords))

      const newImagingWhichUpdated = {
        name: selectedImagingType.Name,
        imagingType,
        impression: impression,
        comment: comment,
        keywords: uniqueKeywords,
        priority: selectedImagingType.Priority,
        selectedText: highLightText,
      }

      await PatientImagingsCRUD('UPDATE', patientID.toString(), JSON.stringify(newImagingWhichUpdated), date?.toString(), updateModalEditId.toString())

      setDate(getFormattedDate())
      setImagingType('')
      setImpression('')
      setComment('')
      setSelectedImagingType(null)
      setEditImagingId(null)
      setModalVisible(false)
      setDiagnosisModalVisible(false)
      setListImagings([])
      setUpdateModaEditId(null)
      setRender((p) => !p)
      setHighLightText([])
      
    } else {
      for (const item of listImagings) {
        await saveImaging(item?.date, item?.selectedImagingType, item?.impression, item.type === 'existing', item?.editId, item?.selectedText)
      }

      toast.success('Successfully Save without adding diagnosis', toastConfig)
      await GetPatientImagings()
      setImpression('')
      setDate(getFormattedDate())
      setImagingType('')
      setComment('')
      setSelectedImagingType(null)
      setModalVisible(false)
      setDiagnosisModalVisible(false)
      setListImagings([])
      setEditImagingId(null)
      setRender((p) => !p)
      setHighLightText([])
    }
  }

  const extractFromOldHtml = (html) => {
    if (!html) return null

    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html

    // Get the full text (impression)
    const impression = tempDiv.textContent || tempDiv.innerText || ''

    // Find all elements that look like highlights and extract their text
    const highlightElements = tempDiv.querySelectorAll('strong, b, mark, .highlight, .highlighted, [style*="font-weight"], [style*="background"]')

    const selectedText = []
    highlightElements.forEach((el) => {
      const text = el.textContent?.trim()
      if (text && !selectedText.includes(text)) {
        selectedText.push(text)
      }
    })

    return {
      impression: impression.trim(),
      selectedText: selectedText,
    }
  }

  const handleUpdateImagingSmallModal = async () => {

       setIsSavingAll(true) // Start loading

    const sanitizedImpression = impression.replace(/[^a-zA-Z0-9\s]/g, '')

    // Split the sanitized impression into keywords
    const inputKeywords = sanitizedImpression
      .toLowerCase()
      .split(/\s+/)
      .filter((keyword) => keyword.trim() !== '')
    detectedKeywordsRef.current.clear() // Clear previous keywords

    let diagnosisData = await GetDiagnosisData()
    let tempData = JSON.parse(diagnosisData.d)?.Data

    const possibleDiagnosis = tempData.filter((diagnosis) => {
      const diagnosisKeywords = (diagnosis?.Keywords || '').split(',').map((keyword) => keyword.trim().toLowerCase())
      let match = true
      diagnosisKeywords.find((diagnosisKeyword) => {
        match = true

        const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/)
        if (diagnosisKeywordParts.length > 1) {
          let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0])

          if (foundIndex != -1) {
            for (let i = 1; i <= diagnosisKeywordParts.length - 1; i++) {
              if (inputKeywords.length < foundIndex + i) {
                match = false
                break
              }
              if (diagnosisKeywordParts[i] != inputKeywords[foundIndex + i]) {
                match = false
                break
              }
            }
          } else {
            match = false
          }
        } else {
          let foundKeyword = inputKeywords.includes(diagnosisKeyword)
          if (!foundKeyword) {
            match = false
          } else {
            match = true
          }
        }
        if (match) {
          return true
        }
      })
      if (match) {
        diagnosisKeywords.forEach((keyword) => detectedKeywordsRef.current.add(keyword))
      }
      return match
    })
    let result = possibleDiagnosis.filter((item) => !diagnosis.includes(item.Name.trim()))
    setPossibleDiagnosis(result)
    if (result.length > 0) {
      setDiagnosisModalVisible(true)
    } else {
      // const filteredKeywords = selectedImagingType.Keywords.map((item) => item.keyword)

      const filteredKeywords = Array.isArray(selectedImagingType.Keywords)
        ? selectedImagingType.Keywords.map((item) => item.keyword)
        : []
            .filter((item) => item !== '')
            .flatMap((item) => item.split(','))
            .map((keyword) => keyword.trim())

      const uniqueKeywords = Array.from(new Set(filteredKeywords))

      const newImagingWhichUpdated = {
        name: selectedImagingType.Name,
        imagingType,
        impression: impression,
        comment: comment,
        keywords: uniqueKeywords,
        priority: selectedImagingType.Priority,
        selectedText: highLightText,
      }

      await PatientImagingsCRUD('UPDATE', patientID.toString(), JSON.stringify(newImagingWhichUpdated), date?.toString(), updateModalEditId.toString())

      setDate(getFormattedDate())
      setImagingType('')
      setImpression('')
      setComment('')
      setSelectedImagingType(null)
      setEditImagingId(null)
      setModalVisible(false)
      setDiagnosisModalVisible(false)
      setListImagings([])
      setUpdateModaEditId(null)
      setRender((p) => !p)
      setHighLightText([])
    }
           setIsSavingAll(false) // Start loading

  }
  // const handleAddSelections = (idx) => {
  //   const addSelection = window.getSelection().toString().trim()
  //   if (addSelection) {
  //     setListImagings((prevList) => {
  //       const updatedList = [...prevList]
  //       const currentItem = updatedList[idx]

  //       const currentSelections = currentItem.selectedText || []

  //       if (!currentSelections.includes(addSelection)) {
  //         updatedList[idx] = {
  //           ...currentItem,
  //           selectedText: [...currentSelections, addSelection],
  //         }
  //       }

  //       return updatedList
  //     })
  //     setSelectedText("")
  //   }
  // }

  // const handleAddSelections = (idx) => {
  //   const selection = window.getSelection()
  //   const text = selection.toString().trim()
  //   if (!text) return

  //   const range = selection.getRangeAt(0)
  //   // Get offset relative to the text container
  //   const preSelectionRange = range.cloneRange()
  //   preSelectionRange.selectNodeContents(range.startContainer.parentNode)
  //   preSelectionRange.setEnd(range.startContainer, range.startOffset)
  //   const start = preSelectionRange.toString().length

  //   const newHighlight = { start, end: start + text.length, text }

  //   setListImagings((prevList) => {
  //     const updatedList = [...prevList]
  //     const currentItem = updatedList[idx]
  //     const currentSelections = currentItem.selectedText || []

  //     const alreadyExists = currentSelections.some(s => s.start === start && s.end === start + text.length)
  //     if (!alreadyExists) {
  //       updatedList[idx] = { ...currentItem, selectedText: [...currentSelections, newHighlight] }
  //     }
  //     return updatedList
  //   })
  // }
  // Utility: count chars from container start to a node+offset
  const getTextOffset = (container, targetNode, targetOffset) => {
    let charCount = 0
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
    while (walker.nextNode()) {
      const node = walker.currentNode
      if (node === targetNode) {
        charCount += targetOffset
        return charCount
      }
      charCount += node.textContent.length
    }
    return charCount
  }

  // const handleAddSelections = (idx) => {
  //   const selection = window.getSelection()
  //   const text = selection.toString().trim()
  //   if (!text) return

  //   const range = selection.getRangeAt(0)

  //   // Find the impression container using data attribute
  //   const container = range.startContainer?.parentElement?.closest(`[data-impression="${idx}"]`)
  //     || document.querySelector(`[data-impression="${idx}"]`)

  //   if (!container) return

  //   const start = getTextOffset(container, range.startContainer, range.startOffset)
  //   const newHighlight = { start, end: start + text.length, text }

  //   setListImagings((prevList) => {
  //     const updatedList = [...prevList]
  //     const currentItem = updatedList[idx]
  //     const currentSelections = currentItem.selectedText || []
  //     const alreadyExists = currentSelections.some(s => s.start === start && s.end === start + text.length)
  //     if (!alreadyExists) {
  //       updatedList[idx] = { ...currentItem, selectedText: [...currentSelections, newHighlight] }
  //     }
  //     return updatedList
  //   })

  //   window.getSelection().removeAllRanges()
  //   setSelectedText('')
  // }

  // const handleRemoveSelections = (idx) => {
  //   const removeSelection = window.getSelection().toString().trim()
  //   if (removeSelection) {
  //     setListImagings((prevList) => {
  //       const updatedList = [...prevList]
  //       const currentItem = updatedList[idx]

  //       const currentSelections = currentItem.selectedText || []

  //       updatedList[idx] = {
  //         ...currentItem,
  //         selectedText: currentSelections.filter(item => item !== removeSelection),
  //       }

  //       return updatedList
  //     })
  //     setSelectedText("")
  //   }
  // }

  const handleRemoveSelections = (idx) => {
    const text = window.getSelection().toString().trim()
    if (!text) return

    setListImagings((prevList) => {
      const updatedList = [...prevList]
      const currentItem = updatedList[idx]
      updatedList[idx] = {
        ...currentItem,
        selectedText: (currentItem.selectedText || []).filter((s) => s.text !== text),
      }
      return updatedList
    })
  }

  const [showUpdateHighlight, setShowUpdateHighlight] = useState(false)
  const [updateHighlightImagingData, setUpdateHighlightImagingData] = useState(null)
  // const handleAddSelectionsWhileUpdate = () => {
  //   const selection = window.getSelection().toString().trim()
  //   if (!selection) return

  //   setUpdateHighlightImagingData((prevList) => {
  //     const updatedList = {
  //       ...prevList,
  //       data: {
  //         ...prevList.data,
  //         selectedText: [
  //           ...(prevList.data?.selectedText || []),
  //         ],
  //       },
  //     }

  //     if (!updatedList.data.selectedText.includes(selection)) {
  //       updatedList.data.selectedText = [
  //         ...updatedList.data.selectedText,
  //         selection,
  //       ]
  //     }

  //     return updatedList
  //   })
  // }
  // const handleAddSelectionsWhileUpdate = () => {
  //   const selection = window.getSelection()
  //   const text = selection.toString().trim()
  //   if (!text) return

  //   const range = selection.getRangeAt(0)
  //   const container = document.querySelector('[data-impression="update"]')
  //   if (!container) return

  //   const start = getTextOffset(container, range.startContainer, range.startOffset)
  //   const newHighlight = { start, end: start + text.length, text }

  //   setUpdateHighlightImagingData((prev) => {
  //     const currentSelections = prev.data?.selectedText || []
  //     const alreadyExists = currentSelections.some(s => s.start === start && s.end === start + text.length)
  //     if (alreadyExists) return prev
  //     return {
  //       ...prev,
  //       data: { ...prev.data, selectedText: [...currentSelections, newHighlight] },
  //     }
  //   })

  //   window.getSelection().removeAllRanges()
  //   setSelectedText('')
  // }

  // const handleAddSelectionsWhileUpdate = () => {
  //   if (!selectedText) return  // guard using state, not re-calling getSelection

  //   const selection = window.getSelection()
  //   if (!selection.rangeCount) return

  //   const range = selection.getRangeAt(0)
  //   const container = document.querySelector('[data-impression="update"]')
  //   if (!container) return

  //   const start = getTextOffset(container, range.startContainer, range.startOffset)
  //   const newHighlight = { start, end: start + selectedText.length, text: selectedText }

  //   setUpdateHighlightImagingData((prev) => {
  //     const currentSelections = prev.data?.selectedText || []
  //     const alreadyExists = currentSelections.some(s => s.start === start && s.end === start + selectedText.length)
  //     if (alreadyExists) return prev
  //     return {
  //       ...prev,
  //       data: { ...prev.data, selectedText: [...currentSelections, newHighlight] },
  //     }
  //   })

  //   window.getSelection().removeAllRanges()
  //   setSelectedText('')  // already there, but make sure it's called
  // }

  // const handleAddSelectionsWhileUpdate = () => {
  //   if (!selectedText || !selectionRange) return

  //   const newHighlight = {
  //     start: selectionRange.start,
  //     end: selectionRange.end,
  //     text: selectedText
  //   }

  //   setUpdateHighlightImagingData((prev) => {
  //     const currentSelections = prev.data?.selectedText || []
  //     const alreadyExists = currentSelections.some(
  //       s => s.start === selectionRange.start && s.end === selectionRange.end
  //     )
  //     if (alreadyExists) return prev
  //     return {
  //       ...prev,
  //       data: { ...prev.data, selectedText: [...currentSelections, newHighlight] },
  //     }
  //   })

  //   window.getSelection().removeAllRanges()
  //   setSelectedText('')
  //   setSelectionRange(null)
  // }

  // const handleRemoveSelectionsWhileUpdate = () => {
  //   const selection = window.getSelection().toString().trim()
  //   if (!selection) return

  //   setUpdateHighlightImagingData((prevList) => {
  //     const updatedList = {
  //       ...prevList,
  //       data: {
  //         ...prevList.data,
  //         selectedText: [...(prevList.data?.selectedText || [])],
  //       },
  //     }

  //     if (updatedList.data.selectedText.includes(selection)) {
  //       updatedList.data.selectedText = updatedList.data.selectedText.filter(
  //         (item) => item !== selection
  //       )
  //     }

  //     return updatedList
  //   })
  // }\
  //   const handleRemoveSelectionsWhileUpdate = () => {
  //   const text = window.getSelection().toString().trim()
  //   if (!text) return

  //   setUpdateHighlightImagingData((prev) => ({
  //     ...prev,
  //     data: {
  //       ...prev.data,
  //       selectedText: (prev.data?.selectedText || []).filter(s => s.text !== text),
  //     },
  //   }))
  // }

  const formatFreeTypeHtml = (html = '') => {
    if (!html) return ''

    // Replace inline style font-weight (any value) → add orange color
    return (
      html
        .replace(/style="([^"]*)font-weight:\s*[\w]+;?([^"]*)"/gi, (_, before, after) => `style="${before}color: orange; font-weight: 600;${after}"`)
        // Also handle plain <b> tags
        .replace(/<b>/gi, '<span style="color: orange; font-weight: 600;">')
        .replace(/<\/b>/gi, '</span>')
        // Also handle <strong> tags
        .replace(/<strong(\s[^>]*)?>/gi, (_, attrs) => `<strong${attrs || ''} style="color: orange; font-weight: 600;">`)
    )
  }

  const handleUpdateHighlights = async () => {
    if (!updateHighlightImagingData) return
    await PatientImagingsCRUD('UPDATE', updateHighlightImagingData?.patientID?.toString(), JSON.stringify(updateHighlightImagingData?.data), updateHighlightImagingData?.date?.toString(), updateHighlightImagingData?.id.toString())
    setShowUpdateHighlight(false)
    setUpdateHighlightImagingData(null)
    await GetPatientImagings()
  }
  //     const handleSelection = () => {
  //   const text = window.getSelection()?.toString().trim() || '';
  //   setSelectedText(text);
  // };

  // const handleSelection = () => {
  //   const selection = window.getSelection()
  //   const text = selection?.toString().trim() || ''
  //   if (!text || !selection.rangeCount) {
  //     setSelectedText('')
  //     return
  //   }
  //   setSelectedText(text)
  // }
  const [selectionRange, setSelectionRange] = useState(null)

  const handleSelection = () => {
    const selection = window.getSelection()
    const text = selection?.toString().trim() || ''

    if (!text || !selection.rangeCount) {
      setActiveSelection(null)
      return
    }

    const range = selection.getRangeAt(0)
    const container = document.querySelector('[data-impression="update"]')
    if (!container) {
      setActiveSelection(null)
      return
    }

    const start = getTextOffset(container, range.startContainer, range.startOffset)
    setActiveSelection({ start, end: start + text.length, text })
  }

  const selectionOverlapsHighlight = (selection, highlights = []) => {
    if (!selection || !highlights?.length) return false
    return highlights.some((h) => typeof h === 'object' && selection.start < h.end && selection.end > h.start)
  }

  const addHighlight = (highlights = []) => {
    if (!activeSelection) return highlights
    const alreadyExists = highlights.some((h) => h.start === activeSelection.start && h.end === activeSelection.end)
    if (alreadyExists) return highlights
    return [...highlights, { start: activeSelection.start, end: activeSelection.end, text: activeSelection.text }]
  }

  const removeOverlappingHighlights = (highlights = []) => {
    if (!activeSelection) return highlights
    return highlights.filter((h) => !(activeSelection.start < h.end && activeSelection.end > h.start))
  }


    // Modified save all handler
  const handleSaveAllImaging = async () => {
console.log('listImagings',listImagings.length)
     if (listImagings.length === 0) {
    toast.error('Please add at least one imaging before saving', toastConfig)
    return // Don't proceed with loading state
  }


    setIsSavingAll(true) // Start loading
    
    try {
      await filterDiagnosis()
      // The modal will be closed in addDiagnosis or continueWithoutSaving after successful save
    } catch (error) {
      console.error('Error in save all:', error)
      toast.error('Failed to save. Please try again.', toastConfig)
      setIsSavingAll(false)
    }
  }

  // const isAlreadyHighlighted = (selectedText, highlights = []) => {
  //   if (!selectedText || !highlights?.length) return false
  //   return highlights.some(h =>
  //     typeof h === 'object' && h.text === selectedText
  //   )
  // }
  // const isAlreadyHighlighted = (selectedText, highlights = [], range = null) => {
  //   if (!selectedText || !highlights?.length) return false

  //   // Exact text match
  //   if (highlights.some(h => typeof h === 'object' && h.text === selectedText)) return true

  //   // Overlap check using pre-captured range
  //   if (!range) return false
  //   return highlights.some(h => {
  //     if (typeof h !== 'object') return false
  //     return range.start < h.end && range.end > h.start
  //   })
  // }
const sortedImagings = [...listImagings].sort((a, b) => {
  const priorityA = Number(a.selectedImagingType?.Priority ?? 999);
  const priorityB = Number(b.selectedImagingType?.Priority ?? 999);

  console.log('Sorted Imagings:', a.selectedImagingType?.Name, 'Priority:', priorityA, '|', b.selectedImagingType?.Name, 'Priority:', priorityB);
  return priorityA - priorityB;
});

// Keep Current Imagings in ascending priority order: 0, 1, 2, etc.
// Entries without a priority are displayed last.
const currentImagings = [...imagingList]
  .filter((imgEntry) =>
    noteStructureRef?.current?.metadata?.imagingIds?.includes(Number(imgEntry.id)),
  )
  .sort((a, b) => {
    const priorityA = Number(a.data?.priority ?? 999)
    const priorityB = Number(b.data?.priority ?? 999)

    return priorityA - priorityB
  })


  return (
    <>
      {/* highlighyt edit modal */}
      <CModal 
        onClose={()=>{
          setUpdateHighlightImagingData(null)
          setShowUpdateHighlight(false)
        }} 
        size="lg" 
        visible={showUpdateHighlight}
        className="dashboard-dark-modal patient-theme-modal"
      >
        <CModalHeader>
          <CModalTitle>Update Highlights</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div 
            className="p-4" 
            data-impression="update" 
            style={{ 
              whiteSpace: 'pre-line',
              backgroundColor: 'var(--ui-bg-inset, #1b1b1b)',
              border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
              borderRadius: '8px',
              color: 'var(--ui-text-primary, #ffffff)'
            }} 
            onMouseUp={handleSelection}
          >
            <div>{renderHighlightedText(updateHighlightImagingData?.data?.impression, updateHighlightImagingData?.data?.selectedText)}</div>
          </div>
          <div className="d-flex gap-2 align-items-center mt-3">
            <CButton
              style={{ 
                fontSize: '12px',
                backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
                borderColor: 'var(--ui-color-primary, #2b7cd3)',
                color: 'white',
                fontWeight: '600'
              }}
              onClick={() => {
                if (!activeSelection) return
                const current = updateHighlightImagingData?.data?.selectedText || []
                const isOverlapping = selectionOverlapsHighlight(activeSelection, current)

                setUpdateHighlightImagingData((prev) => ({
                  ...prev,
                  data: {
                    ...prev.data,
                    selectedText: isOverlapping ? removeOverlappingHighlights(current) : addHighlight(current),
                  },
                }))

                window.getSelection().removeAllRanges()
                setActiveSelection(null)
              }}
            >
              {activeSelection && selectionOverlapsHighlight(activeSelection, updateHighlightImagingData?.data?.selectedText) ? 'Remove Highlight' : 'Add Highlight'}
            </CButton>
          </div>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setUpdateHighlightImagingData(null)
              setShowUpdateHighlight(false)
            }}
            color="secondary"
          >
            Close
          </CButton>
          <CButton 
            onClick={handleUpdateHighlights} 
            style={{
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              borderColor: 'var(--ui-color-primary, #2b7cd3)',
              color: 'white',
              fontWeight: '600',
              marginLeft: '10px'
            }}
          >
            Update
          </CButton>
        </CModalFooter>
      </CModal>

      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={handleDeleteImagingPatient} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      {/* <CModal backdrop="static" size="xl" visible={diagnosisModalVisible} onClose={() => setDiagnosisModalVisible(false)}> */}
      <CModal
        className="dashboard-dark-modal patient-theme-modal patient-labs-modal"
        backdrop="static"
        size="xl"
        visible={diagnosisModalVisible}
        // onClose={() => {
        //   setDiagnosisModalVisible(false)
        //   setDiagnosisActiveSelection(null) // add this
        // }}

    //         onClose={() => {
    //       if (!isSavingAll) { // Only allow close if not saving
    //         setDiagnosisModalVisible(false)
    //         setDiagnosisActiveSelection(null)

    //             setIsSavingAll(false)       // ← always reset, no if-guard
    // setIsAddingDiagnosis(false) // ← always reset

    // setIsLoading(false)
       
    //       }
    //     }}

          onClose={() => {
    if (!isAddingDiagnosis) { // Only allow close if not adding diagnosis
      setDiagnosisModalVisible(false)
      setDiagnosisActiveSelection(null)
      setIsSavingAll(false)       // ← Reset saving state
      setIsAddingDiagnosis(false) // ← Reset adding diagnosis state
      setIsLoading(false)         // ← Reset loading state
    }
  }}

      >
      <CModalHeader
  onClose={() => {
    setDiagnosisModalVisible(false)
    setDiagnosisActiveSelection(null)
    setIsSavingAll(false)       // ← Add this
    setIsAddingDiagnosis(false) // ← Add this
    setIsLoading(false)         // ← Add this
  }}
>
          <CModalTitle>Detected Diagnosis</CModalTitle>
        </CModalHeader>     
        <CModalBody
         
        >
          <div className="d-flex "  style={{ overflow:"auto" , minHeight: '50vh' }}  > 
             
            <div style={{ minWidth: '70%', maxWidth: '70%', width: '70%',  }} className="flex-fill me-3 ">
              <div className="gap-4 d-flex flex-column">
                {listImagings.length > 0 &&
                  sortedImagings.map((item, index) => {
                    const isThisItemSelected = diagnosisActiveSelection?.index === index
                    const isOverlapping = isThisItemSelected && selectionOverlapsHighlight(diagnosisActiveSelection, item?.selectedText || [])

                    return (
                      <div key={index} className="d-flex gap-2 flex-column">
                        <div className="mb-2">
                          <strong>Imaging Type:</strong> {item?.name}
                        </div>

                        <div data-impression={`diagnosis-${index}`} onMouseUp={() => handleDiagnosisSelection(index)} className="text-display">
                          <div>{renderHighlightedText(item?.impression, item?.selectedText)}</div>
                        </div>

                        <div className="d-flex gap-2 align-items-center">
                          <CButton
                            variant="outline"
                            style={{ fontSize: '12px' }}
                            color="primary"
                            onClick={() => {
                              if (!diagnosisActiveSelection || diagnosisActiveSelection.index !== index) return

                              setListImagings((prevList) => {
                                const updatedList = [...prevList]
                                const current = updatedList[index]?.selectedText || []
                                updatedList[index] = {
                                  ...updatedList[index],
                                  selectedText: isOverlapping
                                    ? current.filter((h) => !(diagnosisActiveSelection.start < h.end && diagnosisActiveSelection.end > h.start))
                                    : [...current.filter((h) => !(diagnosisActiveSelection.start < h.end && diagnosisActiveSelection.end > h.start)), { start: diagnosisActiveSelection.start, end: diagnosisActiveSelection.end, text: diagnosisActiveSelection.text }],
                                }
                                return updatedList
                              })

                              window.getSelection().removeAllRanges()
                              setDiagnosisActiveSelection(null)
                            }}
                          >
                            {isThisItemSelected && isOverlapping ? 'Remove Highlight' : 'Add Highlight'}
                          </CButton>
                        </div>
                      </div>
                    )
                  })}
              </div>
            </div>
            <div className="flex-fill">
              <h5>Detected Diagnosis</h5>
             
              {possibleDiagnosis.map((diagnosis, index) => (
                <CBadge key={index} color="info" className="d-flex align-items-center gap-2 me-2 mr-1 mb-1 text-white" style={{ cursor: 'pointer', width: 'fit-content', maxWidth: '100%' }}>
                  {diagnosis.Name}
                  <X onClick={() => handleRemoveDiagnosis(index)} size={15} />
                </CBadge>
              ))}
              <hr />
              <h5>Existing Diagnosis</h5>
              {diagnosis.map((diagnosisItem, index) => (
                <CBadge
                  key={index}
                  color="primary"
                  className="me-2 mr-1 mb-1"
                >
                  {diagnosisItem}
                </CBadge>
              ))}
            </div>
          </div>
        </CModalBody>
        <CModalFooter>
          {/* <CButton variant="outline" color="primary" onClick={addDiagnosis}  >
            Add Diagnosis
            
          </CButton> */}

            <CButton
    className="patient-page-action-btn"
    variant="outline"
    color="primary"
    onClick={addDiagnosis}
    disabled={isAddingDiagnosis|| possibleDiagnosis?.length === 0}
     style={{
    border: '1px solid #321fdb',
    opacity: isAddingDiagnosis || possibleDiagnosis?.length === 0 ?  0.5 : 1, // prevent faded look
    cursor:
      isAddingDiagnosis || possibleDiagnosis?.length === 0
        ? 'not-allowed'
        : 'pointer',
  }}
  >
    {isAddingDiagnosis ? (
      <CSpinner component="span" size="sm" aria-hidden="true" />
    ) : (
      'Add Diagnosis'
    )}
  </CButton>


          <CButton variant="outline" color="secondary" className="patient-page-action-btn" onClick={continueWithoutSaving}>
            Continue without adding
          </CButton>
        </CModalFooter>
      </CModal>

      <CButton style={{ marginTop: '10px' }} className="stick-patient-btn patient-page-action-btn" onClick={handleAddImaging} variant="outline" color="primary">
        + Add Imaging
      </CButton>

      <div>
        <div>
          <hr className="hr-text" data-content="Current Imagings" />

          {currentImagings.map((imgEntry, index) => {
              return (
                <Carder
                  EditHighlightFunc={() => {
                      console.log("Edit highlight clicked for:", imgEntry);
                    setUpdateHighlightImagingData(imgEntry)
                    setShowUpdateHighlight(true)
                  }}
                  editFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => handleUpdatePatientImaging(imgEntry) : null}
                  deleteFunc={() => setDeleteVisibleId(imgEntry.id)}
                  // deleteFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => setDeleteVisibleId(imgEntry.id) : null}
                  key={index}
                  style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
                  className="mt-3 overflow-hidden"
                >
                  <CCardBody>
                    <div className="mb-3">
                      Date:{' '}
                      {new Date(imgEntry.date).toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                      })}
                    </div>
                    <div>
                      <div className="mb-2">
                        <strong>Imaging Type:</strong> {imgEntry.data?.name}
                      </div>
                      <div className="mb-3">
                        <strong>Impression:</strong>
                        <div
                          className="bg-secondary p-2 mt-2"
                          style={{
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {/* <Highlighter /> */}

                          {/* <Highlighter
                            highlightClassName="YourHighlightClass"
                            autoEscape={true}
                            textToHighlight={imgEntry?.data?.impression}
                             highlightStyle={{  backgroundColor: "white",color: 'orange', background: "inherit" }}
                            searchWords={[
                              // ...(imgEntry?.data?.keywords || []),
                              ...(imgEntry?.data?.selectedText && imgEntry?.data?.selectedText.length > 0
                                ? imgEntry?.data?.selectedText
                                : []
                              )
                            ]}
                          /> */}

                          {/* <div>{renderHighlightedText(item?.impression, item?.selectedText)}</div> */}
                          <div>{renderHighlightedText(imgEntry?.data?.impression, imgEntry?.data?.selectedText)}</div>
                          {/* <p style={{ whiteSpace: 'pre-wrap' }}>{imgEntry?.data?.impression}</p> */}
                          {/* <HighlightedTextImaging text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedTextImaging> */}

                          {/* <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText> */}
                        </div>
                      </div>
                      {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
                    </div>

                    {/* <CTable>
                                <CTableHead>
                                    <CTableRow>
                                        <CTableHeaderCell>Imaging Type</CTableHeaderCell>
                                        <CTableHeaderCell>Impression</CTableHeaderCell>

                                    </CTableRow>
                                </CTableHead>
                                <CTableBody>
                                    <CTableRow>
                                        <CTableDataCell style={{ width: "40%" }} className='' valign="">{imgEntry.data?.name}</CTableDataCell>
                                        <CTableDataCell style={{ width: "60%" }} className='' valign="" >
                                            <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
                                        </CTableDataCell>


                                    </CTableRow>
                                </CTableBody>
                            </CTable> */}
                  </CCardBody>
                </Carder>
              )
          })}
          {currentImagings.length === 0 && <div className="text-center text-muted my-4">No Current Imagings Found.</div>}

          {noteStructureRef?.current?.freeTypesEverything?.imagingHtml && (
            <>
              <hr className="hr-text mt-4" data-content="Old Imagings" />

              <div className="mt-2">
                <div
                  className="p-4 patient-theme-old-data patient-theme-old-data--readonly"
                  onClick={() => {
                    // setShowEditHtml(true)
                    setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.imagingHtml || '')
                  }}
                  // dangerouslySetInnerHTML={{__html:noteStructureRef?.current?.freeTypesEverything?.imagingHtml}}
                  dangerouslySetInnerHTML={{ __html: formatFreeTypeHtml(noteStructureRef?.current?.freeTypesEverything?.imagingHtml) }}
                ></div>
              </div>
            </>
          )}
          {/* 
{noteStructureRef?.current?.freeTypesEverything?.imagingHtml && (
  <>
    <hr className="hr-text mt-4" data-content="Old Imagings" />
    <div className='mt-2'>
      <div
        className='p-4'
        style={{background:"#f6f6f6ff", borderRadius:"10px"}}
        onClick={() => {
          setShowEditHtml(true);
          setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.imagingHtml || '');
        }}
      >
        {(() => {
          const extracted = extractFromOldHtml(noteStructureRef.current.freeTypesEverything.imagingHtml);
          if (extracted && extracted.selectedText.length > 0) {
            // We found highlights, render with your function
            return renderHighlightedText(extracted.impression, extracted.selectedText);
          } else {
            // No highlights found, just show the text
            return <div>{extracted?.impression || noteStructureRef.current.freeTypesEverything.imagingHtml.replace(/<[^>]*>/g, '')}</div>;
          }
        })()}
      </div>
    </div>
  </>
)} */}
        </div>

        <div>{/* here the old imaging was at the bottom */}</div>
      </div>

      <CModal
        className="dashboard-dark-modal patient-theme-modal patient-labs-modal"
        backdrop="static"
        size="xl"
        scrollable
        alignment="center"
        contentClassName="d-flex flex-column"
        visible={modalVisible}
        // onClose={() => {
        //   setModalVisible(false)
        //   setActiveTab('add')
        //   setListImagings([])
        //   setImpression('')
        //   setEditImagingId(null)
        //   setImagingType('')
        //   setDate(getFormattedDate())
        //   setSelectedImagingType(null)
        // }}

             onClose={() => {
         if (!isSavingAll) { // Only allow close if not saving
            setModalVisible(false)
            setActiveTab('add')
            setListImagings([])
            resetAddImagingForm()
               setIsSavingAll(false) // Reset loading state when closing
      setIsLoading(false) // Reset any other loading states
          }
        }}


      >
        <CModalHeader 
        // onClose={() => setModalVisible(false)}

         onClose={() => {
          if (!isSavingAll) {
            setModalVisible(false)
            setActiveTab('add')
            setListImagings([])
            resetAddImagingForm()
                setIsSavingAll(false) 
          }
        }}
          
          >
          <CModalTitle>Patient Imaging</CModalTitle>
        </CModalHeader>
        <CModalBody
          className="imaging-tabs"
          
        >
          <div style={{ minHeight: '60vh', maxHeight: '60vh', overflowY: 'auto' }}>
              <CNav className="justify-content-center gap-2 mb-3" variant="pills">
            <CNavItem>
              <CNavLink active={activeTab === 'add'} onClick={() => setActiveTab('add')} style={{ cursor: 'pointer' }}>
                Add
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink active={activeTab === 'list'} onClick={() => setActiveTab('list')} style={{ cursor: 'pointer' }}>
                List
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeTab === 'add'}>
              <div className="mb-3 " style={{ width: '20%' }}>
                <CFormLabel>Date</CFormLabel>

                <span className="d-block ml-2">
                  <CustomDatePickingFormat value={date} onChange={(e) => setDate(e)} format="mm-dd-yyyy" />
                </span>
              </div>
              <div className="mb-3">
                <CFormLabel>Imaging</CFormLabel>
                <Select
                 className="basic-single-select"
                  classNamePrefix="select"
                  // isMulti={editIndexListId === null}
                  closeMenuOnSelect={editIndexListId !== null}
                  options={getAvailableImagingOptions().map((type) => ({ value: type.ID, label: type.Name }))}
                  value={selectedImagingTypes.map((type) => ({ value: type.ID, label: type.Name }))}
                  onChange={(selectedOption) => {
                    const selectedOptions = Array.isArray(selectedOption)
                      ? selectedOption
                      : selectedOption
                        ? [selectedOption]
                        : []
                    const selectedTypes = selectedOptions
                      .map((option) => imagingTypeList.find((type) => type.ID === option.value))
                      .filter(Boolean)

                    setSelectedImagingTypes(selectedTypes)
                    setSelectedImagingType(selectedTypes[0] || null)
                    setImagingType(selectedTypes[0]?.ID || '')
                  }}
                  placeholder={editIndexListId !== null ? 'Select Imaging Type' : 'Select Imaging Type'}
                  isClearable
                />
              </div>
              {showComment && (
                <div className="mb-3">
                  <CFormLabel>Comment</CFormLabel>
                  <Graytextarea rows={4} value={comment} onChange={(e) => setComment(e.target.value)} />
                </div>
              )}
              <div className="mb-3">
                <CFormLabel>Impression</CFormLabel>
                <Graytextarea rows={4} height={'200px'} value={impression} onChange={(e) => setImpression(e.target.value)} />
              </div>
              <div className="justify-content-center gap-2 d-flex align-items-center">
	                <CButton
	                  className="patient-page-action-btn"
	                  onClick={handleAddImagingtoList}
	                  // disabled={!date && !impression && !imagingType}
	                  variant="outline"
                  color="primary"
                >
                  {editIndexListId !== null ? 'Update Imaging' : 'Add Imaging'}
                </CButton>
                {editIndexListId !== null && (
                  <CButton
                    onClick={() => {
                      setActiveTab('list')
                      resetAddImagingForm()
                    }}
                    // disabled={!date && !impression && !imagingType}
                    variant="outline"
                    color="secondary"
                  >
                    {'Cancel'}
                  </CButton>
                )}
              </div>
              <hr />
            </CTabPane>
            <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeTab === 'list'}>
              <div>
                {listImagings.map((item, index) => {
                  return (
                    <Carder
                      editFunc={() => {
                        handleEditListImaging(index)
                      }}
                      deleteFunc={() => {
                        if (item.type === 'existing') {
                          setDeleteVisibleId(item?.editId)
                        } else {
                          const filterListImaging = listImagings.filter((imaging, i) => i !== index)
                          setListImagings(filterListImaging)
                        }
                      }}
                    >
                      <div className={'p-3'}>
                        <div className="mb-2">
                          <strong>Date:</strong> {item?.date}
                        </div>
                        <div className="mb-2">
                          <strong>Imaging Type:</strong> {item?.name}
                        </div>
                        <div className="mb-3">
                          <strong>Impression:</strong>
                          <div
                            className="p-3 mt-2"
                            style={{
                              whiteSpace: 'pre-wrap',
                              backgroundColor: 'var(--ui-bg-inset, #1b1b1b)',
                              border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)',
                              borderRadius: '8px',
                              color: 'var(--ui-text-primary, #ffffff)'
                            }}
                          >
                            {/* <Highlighter
                              highlightClassName="YourHighlightClass"
                              // searchWords={["and", "or", "the","dog is chasing"]}
                              autoEscape={true}
                              textToHighlight={imaging?.impression}
                              searchWords={[
                                ...(imaging?.filteredKeywords || []),
                                ...(imaging?.selectedText && imaging?.selectedText.length > 0
                                  ? imaging?.selectedText
                                  : [])
                              ]}
                            // textToHighlight="The dog is chasing the cat. Or perhaps they're just playing?"
                            /> */}

                            <div>{renderHighlightedText(item?.impression, item?.selectedText)}</div>
                            {/* <HighlightedTextImaging 
  text={imaging?.impression} 
  keywords={[
    ...(imaging?.filteredKeywords || []),
    ...(imaging?.selectedText && imaging?.selectedText.length > 0 
        ? imaging?.selectedText 
        : [])
  ]} 
/> */}

                            {/* <HighlightedTextImaging text={imaging?.impression} keywords={imaging?.filteredKeywords ?  [...imaging?.filteredKeywords,imaging?.selectedText] : []} /> */}
                          </div>
                        </div>
                      </div>
                    </Carder>
                  )
                })}
              </div>
            </CTabPane>
          </CTabContent>
          </div>
        </CModalBody>
        <CModalFooter>
          {
            <>
              {/* <CButton color="secondary" variant="outline" onClick={() => setModalVisible(false) }> */}

                <CButton 
  className="patient-page-action-btn"
  color="secondary" 
  variant="outline" 
  onClick={() => {
    setModalVisible(false)
    setIsSavingAll(false) // Reset loading state
    setIsLoading(false)
    setListImagings([])
    setActiveTab('add')
    resetAddImagingForm()
  }}
  disabled={isSavingAll}
>
                Cancel
              </CButton>
              {/* <CButton color="secondary" variant='outline' onClick={() => {
                                justGetDiagnosisOutofAllImpressions()
                            }}>Get Diagnosis</CButton> */}

              {/* <CButton
                color="primary"
                variant="outline"
                // onClick={handleSaveImaging}
                // onClick={()=>{
                // }}
                 onClick={handleSaveAllImaging}
                       disabled={isSavingAll}
              >
	                {isLoading ? (
	                  <CSpinner component="span" size="sm" aria-hidden="true" />
	                ) : editImagingId !== null ? (
	                  'Update Imaging'
	                ) : (
                  'Save All'
                )}
              </CButton> */}

	                <CButton
	              className="patient-page-action-btn"
	              color="primary"
	              variant="outline"
	              onClick={handleSaveAllImaging}
	              disabled={isSavingAll}
	            >
	              {isSavingAll ? (
	                <CSpinner component="span" size="sm" aria-hidden="true" />
	              ) : editImagingId !== null ? (
	                'Update Imaging'
	              ) : (
                'Save All'
              )}
            </CButton>
            </>
          }
        </CModalFooter>
      </CModal>

      <CModal
        className="dashboard-dark-modal patient-theme-modal patient-labs-modal"
        size="lg"
        visible={updateModalEditId}
        // onClose={() => {
        //   setUpdateModaEditId(null)
        // }}

            onClose={() => {
          if (!isSavingAll) {
            setUpdateModaEditId(null)
            setIsSavingAll(false) // Reset loading state
      setIsLoading(false)
          }
        }}
      >
        <CModalHeader
          style={{
            fontSize: '20px',
            fontWeight: 500,
          }}
        >
          Update Imaging
        </CModalHeader>
        <CModalBody>
          <span className="d-block ml-2">
            <CustomDatePickingFormat value={date} onChange={(e) => setDate(e)} format="mm-dd-yyyy" />
          </span>
          <div className="mb-3">
            <CFormLabel>Imaging</CFormLabel>
            {/* <CFormSelect value={imagingType} onChange={handleSelectImaging} disabled={isSavingAll}>
              <option value="">Select Imaging Typesss</option>
              {imagingTypeList.map((type, index) => (
                <option key={index} value={type.ID}>
                  {type.Name}
                </option>
              ))}
            </CFormSelect> */}
              <CFormSelect value={imagingType} onChange={handleSelectImaging}>
    <option value="">Select Imaging Type</option>
    {imagingTypeList.map((type, index) => (
      <option key={index} value={type.ID}>
        {type.Name}
      </option>
    ))}
  </CFormSelect>
            {/* <Select
                                placeholder="Select Imaging"
                                    value={{
                                        value: selectedOption?.ID,
                                        label: selectedOption?.Name
                                    }}
                                    onChange={(selectedOption) => {
                                        const selectedType = imagingTypeList.find(i => i.ID === selectedOption?.value);
                                        setImagingType(selectedOption?.value || '');
                                        setSelectedImagingType(selectedType || null);
                                    }}
                                    options={imagingTypeList.map((type) => ({ value: type.ID, label: type.Name }))}
                                /> */}
            {/* <Select
                                    options={imagingOptions}
                                    value={imagingOptions.find((opt) => opt.value === imagingType)}
                                    onChange={(selectedOption) => {
                                        const selectedType = imagingTypeList.find(i => i.ID === selectedOption?.value);
                                        setImagingType(selectedOption?.value || '');
                                        setSelectedImagingType(selectedType || null);
                                    }}

                                    placeholder="Select Imaging Type"
                                    isClearable
                                /> */}
          </div>
          {showComment && (
            <div className="mb-3">
              <CFormLabel>Comment</CFormLabel>
              <Graytextarea rows={4} value={comment} onChange={(e) => setComment(e.target.value)} disabled={isSavingAll} />
            </div>
          )}
          <div className="mb-3">
            <CFormLabel>Impression</CFormLabel>
            <Graytextarea rows={4} height={'200px'} value={impression} onChange={(e) => setImpression(e.target.value)} disabled={isSavingAll}/>
          </div>
          <CModalFooter className="p-0 m-0">
            <CButton
              variant="outline"
              color="secondary"
              // onClick={() => {
              //   setUpdateModaEditId(null)
              //   setDate(getFormattedDate())
              //   setImagingType('')
              //   setImpression('')
              //   setComment('')
              //   setSelectedImagingType(null)
              //   setEditImagingId(null)
              //   setModalVisible(false)
              //   setDiagnosisModalVisible(false)
              //   setListImagings([])
              //   setUpdateModaEditId(null)
              //   setRender((p) => !p)
              //   setHighLightText([])
              // }}

                         onClick={() => {
                if (!isSavingAll) {
                  setUpdateModaEditId(null)
                  setDate(getFormattedDate())
                  setImagingType('')
                  setImpression('')
                  setComment('')
                  setSelectedImagingType(null)
                  setEditImagingId(null)
                  setModalVisible(false)
                  setDiagnosisModalVisible(false)
                  setListImagings([])
                  setUpdateModaEditId(null)
                  setRender((p) => !p)
                  setHighLightText([])
                }
              }}
               disabled={isSavingAll}
            >
              Cancel
            </CButton>
            {/* <CButton variant="outline" color="success" onClick={handleUpdateImagingSmallModal}>
              Update Imaging
            </CButton> */}


	               <CButton
	              className="patient-page-action-btn"
	              variant="outline"
	              color="success"
	              onClick={handleUpdateImagingSmallModal}
	              // disabled={isSavingAll || listImagings.length === 0}
	              disabled={isSavingAll}
	            >
	              {isSavingAll ? (
	                <CSpinner component="span" size="sm" aria-hidden="true" />
	              ) : (
	                'Update Imaging'
	              )}
            </CButton>


          </CModalFooter>
        </CModalBody>
      </CModal>

      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Imaging Content</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  imagingHtml: tempHtmlContent,
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
              setTempHtmlContent('')
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientImaging

// {[...imagingList]
//   .filter(
//     (imgEntry) =>
//       !noteStructureRef?.current?.metadata?.imagingIds?.includes(
//         parseInt(imgEntry.id)
//       )
//   )
//   .reverse().map((imgEntry, index) => {
//     return (
//       <Carder
//         EditHighlightFunc={() => {
//           setUpdateHighlightImagingData(imgEntry)
//           setShowUpdateHighlight(true)
//         }}
//         editFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => handleUpdatePatientImaging(imgEntry) : null}
//         deleteFunc={() => setDeleteVisibleId(imgEntry.id)}
//         // deleteFunc={imagingNoteIdEdit.length > 0 && imagingNoteIdEdit.includes(parseInt(imgEntry.id)) ? () => setDeleteVisibleId(imgEntry.id) : null}
//         key={index}
//         style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
//         className="mt-3 overflow-hidden"
//       >
//         <CCardBody>
//           <div className="mb-3">
//             Date:{' '}
//             {new Date(imgEntry.date).toLocaleDateString('en-US', {
//               month: '2-digit',
//               day: '2-digit',
//               year: 'numeric',
//             })}
//           </div>
//           <div>
//             <div className="mb-2">
//               <strong>Imaging Type:</strong> {imgEntry.data?.name}
//             </div>
//             <div className="mb-3">
//               <strong>Impression:</strong>
//               <div className="bg-secondary p-2" style={{
//                 whiteSpace: "pre-line"
//               }}>
//                 {/* <Highlighter /> */}

//                 <Highlighter
//                   highlightClassName="YourHighlightClass"
//                   autoEscape={true}
//                   textToHighlight={imgEntry?.data?.impression}
//                   searchWords={[
//                     // ...(imgEntry?.data?.keywords || []),
//                     ...(imgEntry?.data?.selectedText && imgEntry?.data?.selectedText.length > 0
//                       ? imgEntry?.data?.selectedText
//                       : []
//                     )
//                   ]}
//                 />
//                 {/* <p style={{ whiteSpace: 'pre-wrap' }}>{imgEntry?.data?.impression}</p> */}
//                 {/* <HighlightedTextImaging text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedTextImaging> */}

//                 {/* <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText> */}
//               </div>
//             </div>
//             {/* <div className="mb-3">Comment: {imgEntry?.data?.comment}</div> */}
//           </div>

//           {/* <CTable>
//                       <CTableHead>
//                           <CTableRow>
//                               <CTableHeaderCell>Imaging Type</CTableHeaderCell>
//                               <CTableHeaderCell>Impression</CTableHeaderCell>

//                           </CTableRow>
//                       </CTableHead>
//                       <CTableBody>
//                           <CTableRow>
//                               <CTableDataCell style={{ width: "40%" }} className='' valign="">{imgEntry.data?.name}</CTableDataCell>
//                               <CTableDataCell style={{ width: "60%" }} className='' valign="" >
//                                   <HighlightedText text={imgEntry?.data?.impression} keywords={imgEntry?.data?.keywords}></HighlightedText>
//                               </CTableDataCell>

//                           </CTableRow>
//                       </CTableBody>
//                   </CTable> */}
//         </CCardBody>
//       </Carder>
//     )
//   })}

//   {
//     [...imagingList]
//   .filter(
//     (imgEntry) =>
//       !noteStructureRef?.current?.metadata?.imagingIds?.includes(
//         parseInt(imgEntry.id)
//       )
//   ).length === 0 && <div className="text-center my-4">No old imagings found.</div>
//   }
